module.exports = "<a class=\"kd-item\"\r\n    ui-sref=\"proyecto.informacion({id_proyecto: $ctrl.data.id_empresa})\"\r\n    ui-sref-opts=\"{reload: true}\">\r\n  <div class=\"nobreak flex\">\r\n    <div class=\"nobreak\">{{::$ctrl.data.titulo}}</div>\r\n    <div class=\"nobreak --text-small\">{{::$ctrl.data.descripcion}}</div>\r\n  </div>\r\n  <span class=\"tag q-tag\">{{::$ctrl.data.uid}}</span>\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/searchbox/lista/item/proyecto/template.html
// module id = 2083
// module chunks = 0